import React from 'react';
import Image from 'next/legacy/image';
import classnames from 'classnames';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { getAgentAnchorId } from 'src/utils/agentUtils';

export interface ExpertCardProps {
  image: string;
  firstName?: string;
  lastName?: string;
  job?: string;
  className?: string;
  /**
   * Custom width classes for the expert card image container
   */
  width?: string;
  /**
   * Custom height classes for the expert card image container
   */
  height?: string;
}

export const defaultExpertCardDimensions = {
  width: 'w-[143px] md:w-[146px] xl:w-[190px]',
  height: 'h-[143px] md:h-[184px] xl:h-[240px]',
};

const ExpertCard: React.FC<ExpertCardProps> = ({
  image,
  firstName,
  lastName,
  job,
  className,
  width = defaultExpertCardDimensions.width,
  height = defaultExpertCardDimensions.height,
}) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/about#${getAgentAnchorId(firstName, lastName)}`);
  };

  return (
    <div
      className={classnames(
        'flex flex-col items-center group cursor-pointer',
        className
      )}
      onClick={handleClick}
    >
      <div className={classNames('relative', width, height)}>
        <Image
          src={image}
          alt={
            firstName || lastName
              ? `Expert ${firstName || ''} ${lastName || ''}`.trim()
              : 'Real estate expert photo'
          }
          layout="fill"
          objectFit="cover"
          className="transition-transform duration-300 hover:scale-105"
        />
      </div>
      {(firstName || lastName) && (
        <div
          className={classNames(
            'text-14-17-0.3 xl:text-16-19-0.3 font-sohneBreitHalbfett uppercase group-hover:text-gold-hover text-left pt-6 pb-2',
            width
          )}
        >
          {firstName && <p>{firstName}</p>}
          {lastName && <p>{lastName}</p>}
        </div>
      )}
      {job && (
        <div
          className={classNames(
            'text-14-17-0.3 xl:text-16-19-0.3 text-black group-hover:text-gold-hover text-left pb-4',
            width
          )}
        >
          {job}
        </div>
      )}
    </div>
  );
};

export default ExpertCard;
